export const brandColors = {
  brandOne: '#02315B',
  brandTwo: '#228300',
} as const;
